import { Tags } from "../../enum/tags";
import { apiSlice } from "../http";

export const conciliationReportInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConciliationReport: builder.query<any, { id: number; date: string }>({
      query: ({ id, date }) => ({
        url: `/divergence/reports/deduction/${id}/${date}`,
        method: "GET",
      }),
      providesTags: [Tags.CONCILIATION_REPORT],
    }),
    generateExcelReport: builder.query<any, { startDate: string, endDate: string, analist?: string, reportType: string, storeCode?: string, regionalId?: string }>(
      {
        query: ({ startDate, endDate, analist, reportType, storeCode, regionalId }) => ({
          url: `/conciliation-report/generate-report?reportType=${reportType}&startDate=${startDate}&endDate=${endDate}${analist ? `&responsibleId=${analist}` : ''}${storeCode ? `&storeCode=${storeCode}` : ''}${regionalId ? `&regionalId=${regionalId}` : ''}`,
          method: "GET",
        }),
        providesTags: [Tags.CONCILIATION_REPORT],
      }
    ),
    getReportPreview: builder.query<{ headers: string[], data: any[] }, { startDate: string, endDate: string, analist?: string, reportType: string, storeCode?: string, regionalId?: string }>(
      {
        query: ({ startDate, endDate, analist, reportType, storeCode, regionalId }) => ({
          url: `/conciliation-report/preview?reportType=${reportType}&startDate=${startDate}&endDate=${endDate}${analist ? `&responsibleId=${analist}` : ''}${storeCode ? `&storeCode=${storeCode}` : ''}${regionalId ? `&regionalId=${regionalId}` : ''}`,
          method: "GET",
        }),
        providesTags: [Tags.CONCILIATION_REPORT],
      }
    )
  }),
  overrideExisting: true,
});

export const { useLazyGetConciliationReportQuery, useLazyGenerateExcelReportQuery, useLazyGetReportPreviewQuery } =
  conciliationReportInformations;
